import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDevices2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDevices2"><Path d="M15.5 9.5H22.5V20.5H15.5V9.5Z" stroke="currentColor"/><Path d="M13 19.5H1.5V17.5H13" stroke="currentColor"/><Path d="M20.5 7V3.5H3.5V17.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconDevices2;
